import { useEffect, useState } from "react";
import { SYSTEM_DARK_QUERY, isSystemDarkNow } from "../common/utils/theme_preference";

// Whether the device is set to dark; updates live when the user flips it.
export const useSystemDark = (): boolean => {
	const [isDark, setIsDark] = useState(isSystemDarkNow);

	useEffect(() => {
		const query = window.matchMedia?.(SYSTEM_DARK_QUERY);
		if (!query) return;
		const onChange = () => setIsDark(query.matches);
		onChange();
		query.addEventListener("change", onChange);
		return () => query.removeEventListener("change", onChange);
	}, []);

	return isDark;
};
